(() => {
  if (window.Shopify?.designMode) return;

  const main = document.getElementById('MainContent');
  const thankYouSection = main?.querySelector(':scope > [id$="__password_thank_you"]');

  if (!thankYouSection) {
    delete document.documentElement.dataset.passwordScreen;
    return;
  }

  const landingSections = Array.from(main.children).filter(
    (section) => section.classList.contains('shopify-section') && section !== thankYouSection
  );
  const originalVisibility = new Map(landingSections.map((section) => [section, section.hidden]));
  let showingThankYou = false;

  function updateScreen() {
    const showThankYou = window.location.hash === '#thank-you';
    const screenChanged = showingThankYou !== showThankYou;
    showingThankYou = showThankYou;

    if (showThankYou) {
      document.documentElement.dataset.passwordScreen = 'thank-you';
    } else {
      delete document.documentElement.dataset.passwordScreen;
    }

    thankYouSection.hidden = !showThankYou;
    landingSections.forEach((section) => {
      section.hidden = showThankYou || originalVisibility.get(section);
    });

    if (showThankYou) {
      const heading = thankYouSection.querySelector('h1, h2');
      heading?.setAttribute('tabindex', '-1');
      heading?.classList.add('focus-none');
      heading?.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else if (screenChanged) {
      let target = main;
      try {
        target = document.getElementById(decodeURIComponent(window.location.hash.slice(1))) || main;
      } catch {
        target = main;
      }
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  }

  updateScreen();
  window.addEventListener('hashchange', updateScreen);
  window.addEventListener('pageshow', updateScreen);
})();
